import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=0fa07601&scoped=true&"
import script from "./Player.vue?vue&type=script&lang=js&"
export * from "./Player.vue?vue&type=script&lang=js&"
import style0 from "./Player.vue?vue&type=style&index=0&id=0fa07601&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa07601",
  null
  
)

export default component.exports